export const CONTRACTOR_SEARCH_SELECT_REGION = 'CONTRACTOR_SEARCH_SELECT_REGION';

export const selectRegion = (selectedRegion) => ({
    type: CONTRACTOR_SEARCH_SELECT_REGION,
    payload: {
        selectedRegion,
    }
})
